import React from 'react';

const TOPIC_STATS_DIMENSIONS = [
  "SegmentCourseId",
  "Title",
  "Name",
  "AchievementId",
  "AchievementName",
  "AchievementVideoId",
  "PartName",
  "SegmentTopicRowStatus",
  "AchRowStatus",
  "AchVideoRowStatus",
  'ShowContentStatus'
  ];
   


const QUESTION_COUNT_DIMENSIONS = [
  "AchievementId",
        "DifficultyLevel",
        "RowStatus",
        "PublisherId"
];

const DEFAULT_DIMENSIONS = [];

const DimensionSelector = React.memo(({ reportType, selectedDimensions, setSelectedDimensions }) => {
  const availableDimensions = reportType === 'topicStats' ? TOPIC_STATS_DIMENSIONS : QUESTION_COUNT_DIMENSIONS;

  const handleCheckboxChange = (dimension) => {
    let nextDimensions = [];
    if (selectedDimensions.includes(dimension)) {
      nextDimensions = selectedDimensions.filter(d => d !== dimension);
      
      // Dependency logic: PartName requires at least one Achievement dimension
      const achievementDims = ['AchievementId', 'AchievementName', 'AchievementVideoId'];
      if (achievementDims.includes(dimension)) {
        const hasAchievementRemaining = achievementDims.some(d => d !== dimension && nextDimensions.includes(d));
        if (!hasAchievementRemaining) {
          nextDimensions = nextDimensions.filter(d => d !== 'PartName');
        }
      }
    } else {
      nextDimensions = [...selectedDimensions, dimension];
    }
    setSelectedDimensions(nextDimensions);
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      <h3 style={{ margin: '0 0 8px 0' }}>Dimensions (Breakdowns)</h3>
      <div style={{ marginBottom: '8px', color: '#666', fontSize: '14px' }}>
        <strong>Default Dimensions:</strong> {DEFAULT_DIMENSIONS.join(', ')}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
      {availableDimensions.map(dimension => {
  const hasRequiredDimension =
    selectedDimensions.includes('AchievementId') ||
    selectedDimensions.includes('AchievementName') ||
    selectedDimensions.includes('AchievementVideoId');

  const shouldDisable =
    dimension === 'PartName' && !hasRequiredDimension;

  return (
    <label key={dimension} style={{ display: 'inline-flex', alignItems: 'center' }}>
      <input
        type="checkbox"
        value={dimension}
        checked={selectedDimensions.includes(dimension)}
        disabled={shouldDisable}
        onChange={() => handleCheckboxChange(dimension)}
        style={{ marginRight: '8px' }}
      />
      {dimension === 'Name' ? 'SubCourseTopicName' : dimension}
    </label>
  );
})}
      </div>
    </div>
  );
});

export default DimensionSelector;
